/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Detail_TitleInputs */

const es_chat_tool_detail_title = /** @type {(inputs: Chat_Tool_Detail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalle de herramienta`)
};

const en_chat_tool_detail_title = /** @type {(inputs: Chat_Tool_Detail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tool detail`)
};

/**
* | output |
* | --- |
* | "Tool detail" |
*
* @param {Chat_Tool_Detail_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_title = /** @type {((inputs?: Chat_Tool_Detail_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_title(inputs)
	return en_chat_tool_detail_title(inputs)
});
export { chat_tool_detail_title as "chat.tool_detail.title" }